import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <main className="grid min-h-[70vh] place-items-center p-6 text-center">
      <div>
        <h1 className="ui-page-title">Page not found</h1>
        <p className="ui-muted mt-3 max-w-none">The page you requested does not exist.</p>
        <Link to="/" className="btn btn-primary mt-6">
          Go to Dashboard
        </Link>
      </div>
    </main>
  );
}

export default NotFoundPage;
